<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50 sticky -top-2 z-20">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <!-- foto, nome e função -->
        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <component
            class="w-10 h-10 rounded-full text-gray-400"
            :is="PhUserCircle"
          ></component>

          <!-- nome -->
          <div class="ps-3">
            <div class="text-base font-semibold">
              {{ row["lutador"] }}
            </div>
          </div>
        </th>

        <!-- total vendido -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <div
              title="total vendido"
              class="text-base font-normal"
            >
              quantidade: <span class="font-semibold text-black"> {{ row["ingressos"] }} </span>
            </div>
            <div
              title="total vendido"
              class="text-base font-normal"
            >
              total vendido: <span class="font-semibold text-green-500"> {{ row["vendas_total"] }} </span>
            </div>
          </div>
        </td>

        <!-- comissão -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <div
              title="total vendido"
              class="text-base"
            >
              lucro: <span class="text-green-500 font-bold"> {{ row["vendas"] }} </span>
            </div>
            <div
              title="total vendido"
              class="text-base"
            >
              comissão: <span class="text-red-500 font-bold"> {{ row["comissao"] }} </span>
            </div>
          </div>
        </td>

        <!-- cache -->
        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <!-- % -->
            <div
              class="font-normal"
              v-if="row['percent']"
            >
              <span class="text-black font-bold"> {{ row["percent"] }}% </span> por venda
            </div>

            <!-- R$ -->
            <div
              class="font-normal"
              v-if="row['amount']"
            >
              <span class="text-black font-bold">R$ {{ row["amount"] }} </span> por venda
            </div>
          </div>
        </td>

        <!-- ações -->
        <!-- <td class="px-4 py-2 sticky -right-5 z-10">
          <div class="flex justify-center font-medium">
            <a
              title="Detalhes do registro"
              @click="showReport(row)"
              class="text-[#227e92] ml-1 hover:underline cursor-pointer bg-white py-2 px-2"
            >
              <component :is="PhInfo" class="h-7 w-7 md:h-6 md:w-6" />
            </a>
          </div>
        </td> -->

      </tr>
    </tbody>
  </table>
</template>

<script setup>
import moment from 'moment'
import { PhFileDoc, PhInfo, PhUserCircle } from '@phosphor-icons/vue'
import { defineProps, ref } from 'vue'
import { storeApp } from '@/store'

const imageServe = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const defaultImg = require('@/assets/logo/icon.png')

const props = defineProps({
  data: [Object, Array]
})

const emit = defineEmits(['delete'])

function formatDate (date) {
  if (date !== null) {
    return moment(date).format('DD/MM/Y')
  }

  return 'não informado'
}

</script>
